import api from "../ApiConfig";
import { Apis } from '../../config';
import { NotificationManager } from 'react-notifications';
import unauthService from "../unauth";



const CreatePaymentChat = async (data) => {
    try {
        const result = await api.post(`${Apis.GetAllPaymentChatPath}/create`, data, {
            // withCredentials: true,
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        let response=JSON.parse(result.data)
        let parsedData=JSON.parse(response.body)
        if (!parsedData.success) {
            NotificationManager.error(parsedData.message);
            return null;
        }
        NotificationManager.success('Payment Chat created successfully.', 'Success')
        return result;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in create chat:', error);
        NotificationManager.error('An error occurred while creating chat.');
        return null;
    }
};

const GetClientPaymentChatListPage = async (filterVal) => {
    try {
        const result = await api.get(`${Apis.GetAllPaymentChatPath}/all/?pageNumber=${filterVal.pageNumber}&pageSize=${filterVal.pageSize}&clientId=${filterVal.clientId}`, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        let parsedData=JSON.parse(result.data)
        let response=JSON.parse(parsedData.body)
        
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return response.data 
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        // NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};

const DeletePaymentClientChat = async (id) => {
    try {
        const result = await api.delete(Apis.GetAllPaymentChatPath+'/delete/'+id,  {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        NotificationManager.success(result.data.message);
        return result.data;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        // NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};

export default {
    CreatePaymentChat,
    GetClientPaymentChatListPage,
    DeletePaymentClientChat
};